import { render, staticRenderFns } from "./DetailMemo.vue?vue&type=template&id=dd60ff20&scoped=true&"
import script from "./DetailMemo.vue?vue&type=script&lang=ts&"
export * from "./DetailMemo.vue?vue&type=script&lang=ts&"
import style0 from "./DetailMemo.vue?vue&type=style&index=0&id=dd60ff20&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd60ff20",
  null
  
)

export default component.exports